import { Injectable } from '@angular/core';
import { ICommunicationEvent } from '../ICommunicationEvent';
import { IosimInfo, PlatformCommunicationEvents } from '@shared/generalInterfaces';
import { BaseDestroyable } from '@core/base-destroyable';
import { IOSimPlusIntegrationService } from '../../../services/iosim-plus-integration/iosim-plus-integration.service';
import { from, map, switchMap, take } from 'rxjs';
import { OrderSimulationInfo, SimulationStatusEnum } from '@shared/iosim-plus/models/simulationStatus';
import { IOSimSimulationInfoQuery } from '../../../services/iosim-simulation.store/iosim-simulation-status-progress.query';

@Injectable({providedIn: 'root'})
export class StartIosimSimulation extends BaseDestroyable implements ICommunicationEvent {
	constructor(private iosimPlusIntegrationService: IOSimPlusIntegrationService,
		private simulationStatusProgressQuery: IOSimSimulationInfoQuery) {
        super();
    }

	get eventName(): string {
		return PlatformCommunicationEvents.StartIosimSimulation;
	}

	async handleEvent(event: any, publishEventFunc?: Function) {
		const orderId = event.data.orderId;
		const publisher = event.eventHeader.publisher;
		const storeEntity = this.simulationStatusProgressQuery.getEntity(orderId);
		const simulationStatus = storeEntity?.progress?.simulationStatus || SimulationStatusEnum.NotStarted;

		switch (simulationStatus) {
			case SimulationStatusEnum.NotStarted:
				this.iosimPlusIntegrationService.getOrderSimulationInfo(orderId, event.data.companyId).pipe(
					switchMap((orderSimulationInfo: OrderSimulationInfo) => {
						return from(this.iosimPlusIntegrationService.startSimulation(
							orderId,
							orderSimulationInfo.orderCode,
							publisher
						)).pipe(
							map((startResult) => ({ orderSimulationInfo, startResult }))
						);
					}),
					take(1)
				).subscribe({
					next: async ({ orderSimulationInfo, startResult }) => {
						if (startResult === null) {
							return;
						}
						const entity = this.simulationStatusProgressQuery.getEntity(orderId);
						if (publishEventFunc) {
							const payload = {
								simulationStatus: `${entity?.progress?.simulationStatus ?? SimulationStatusEnum.InProgress}`,
								startSimulationTime: entity?.progress?.startSimulationTime
									? new Date(entity.progress.startSimulationTime).getTime()
									: 0,
								expectedDuration: entity?.progress?.expectedDuration ?? 0,
								notSupportedScanDate: entity?.notSupportedScanDate ?? false,
								isQualifiedForIoSimPlus: orderSimulationInfo?.isQualifiedForIoSimPlus,
							};
							await publishEventFunc(PlatformCommunicationEvents.IosimProgressResult, [publisher], payload);
						}
					},
				});
				break;
			case SimulationStatusEnum.LowQualityScan:
			case SimulationStatusEnum.Fail:
				this.iosimPlusIntegrationService.getOrderSimulationInfo(orderId, event.data.companyId).pipe(
					take(1)).subscribe((orderSimulationInfo: OrderSimulationInfo) => {
						var iosimInfo = {
							orderId: orderId,
							orderCode: orderSimulationInfo.orderCode,
							viewedScreen: publisher,
							isQualifiedForIoSimPlus: orderSimulationInfo.isQualifiedForIoSimPlus
						} as IosimInfo;
						this.iosimPlusIntegrationService.showStatusInfoModal$.next(iosimInfo);
					});
				break;
			default:
				break;
		}
	}
}
